import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

interface RescanConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (action: any) => void;
  scanName: string;
  action: string;
  loading: boolean
}

const RescanConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  scanName,
  action,
  loading,
}: RescanConfirmDialogProps) => {
  const isCancelAction = action === "cancel";

  return (
    <>
      {isCancelAction ? (
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="rescan-confirm-dialog"
          sx={{
            "& .MuiDialog-paper": {
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "360px",
              height: "250px",
              borderRadius: "4px",
              transform: "translate(-50%, -50%)",
              // padding: "10px 10px 0",
              padding: "10px",
              boxSizing: "border-box",
              overflow: "hidden", // ✅ Prevent scrollbars
            },
          }}
        >
          <DialogTitle
            id="rescan-confirm-dialog"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: "16px",
              color: "#101828",
            }}
          >
            {isCancelAction
              ? "Scan is in progress. Are you sure you want to cancel the file scan?"
              : "Are you sure you want to rescan?"}
          </DialogTitle>
          {isCancelAction && (
            <DialogContent
              sx={{
                textAlign: "center",
                fontWeight: 400,
                fontSize: "14px",
                color: "#667085",
                mt: "8px",
                overflow: "visible", // prevent scrollbar
                maxHeight: "none", // override default
              }}
            >
              If cancelled, the selected files won't be added to this scan.
            </DialogContent>
          )}

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "12px",
              paddingBottom: "24px",
              marginTop: "12px",
            }}
          >
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{
                width: "130px",
                height: "36px",
                color: "#5C5589",
                borderColor: "#D0D5DD",
                textTransform: "none",
              }}
            >
              No
            </Button>
            <Button
              onClick={() => onConfirm(action)}
              variant="contained"
              sx={{
                width: "130px",
                height: "36px",
                backgroundColor: "#FF5A5F",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#e14d50",
                },
              }}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog open={open} onClose={onClose}>
          <DialogTitle sx={{ textAlign: "center", p: 3 }}>
            {scanName.length < 10 ? (
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  Are you sure want to rescan {scanName}?{" "}
                </Typography>
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", fontSize: "18px", mb: 1 }}
                >
                  Are you sure want to rescan{" "}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  {scanName}?{" "}
                </Typography>
              </Box>
            )}
          </DialogTitle>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              variant="contained"
              onClick={() => onConfirm(action)}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={16} sx={{ color: '#FFFFFF' }} /> : null}
              color="primary"
              sx={{ width: 110 }}
            >
              Rescan
            </Button>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{ color: "#6c63ff", width: 110 }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default RescanConfirmDialog;
